<template>
  <base-section
    id="premier-section"
    v-on:retry="props.onRetry"
    heading="Premier - Senaste inbetalda"
    :infoStatus="premier.infoStatus"
    :show-error="premier.error"
  >
    <avtalat-spinner v-if="premier.isLoading" />
    <div v-if="!premier.isLoading">
      <div v-if="premier.data?.length == 0">Inga inrapporterade premier</div>
      <HelpText :text="helpTexts.premier.premier" />
      <div
        v-for="anstallning in premier.data"
        :key="anstallning.arbetsgivareId!"
      >
        <div>
          <div class="text-sm">
            <strong>{{ anstallning.arbetsgivareNamn }}</strong>
          </div>
          <div v-for="premie in anstallning.premier" :key="premie.typKod!">
            <section-row
              :title="premie.typNamn || '-'"
              :sub-title="premie.transaktionsDatum"
              :value="formattedAmountInCurrency(premie.belopp)"
              :value-is-numeric="true"
              :help-text="helpText(premie.typKod!)"
            />
          </div>
        </div>
      </div>
    </div>
  </base-section>
</template>

<script lang="ts" setup>
import { computed } from "vue";

import HelpText from "@/components/ui/HelpText.vue";
import { BaseSection, SectionRow } from "@/components/sections";
import helpTexts from "@/config/helpTexts";
import {
  formattedAmountInCurrency,
} from "@/common/formatters";

import { useAnstalldStore } from "../store";

type Itp2SectionProps = {
  onRetry?: () => void;
};

const props = defineProps<Itp2SectionProps>();
const anstalldStore = useAnstalldStore();

const helpText = (typKod?: string) => {
  switch (typKod) {
    case "Ord":
      return helpTexts.premier.ordPremie;
    case "DpFlex":
      return helpTexts.premier.dpFlexPremie;
    case "Lonevx":
      return helpTexts.premier.lonevxPremie;
    case "Kompl":
      return helpTexts.premier.komplPremie;
    case "Eg":
      return helpTexts.premier.egPremie;
    case "Fril":
      return helpTexts.premier.frilPremie;
    case "Trappa":
      return helpTexts.premier.trappaPremie;
    case "AvstFp":
      return helpTexts.premier.avstFpPremie;
    case "KostnFs":
      return helpTexts.premier.kostnFsPremie;
    case "Utl":
      return helpTexts.premier.utlPremie;
    default:
      return "";
  }
};

const premier = computed(() => anstalldStore.premier);
</script>
